import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useRouter,useRoute} from 'vue-router'
import { useStore } from 'vuex'
import {ref,onMounted} from 'vue'
import request from '@/utils/request'
import { legacyLogicalPropertiesTransformer } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale('zh-cn');

const router = useRouter()
const route = useRoute()
const store = useStore()

onMounted(() => {
  request.get(
    '/api/users/auth'
  ).then((res: any) => {
    store.commit("setLogin", res.data)
  }).catch((res) => {
    console.log("未登录", res)
    router.push({
      path: "/login"
    })
  })

})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_style_provider = _resolveComponent("a-style-provider")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(zhCN),
    theme: {
      token: {
        colorPrimary: '#2B5CDD',
        borderRadius: 4,
      },
    }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_style_provider, {
        transformers: [_unref(legacyLogicalPropertiesTransformer)],
        "hash-priority": "high"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["transformers"])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})